import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { postAddress } from '../services/address';

const useAddressPostData = ({
  onSuccess = () => { },
}) => {
  const { token } = useSelector(state => state);
  return useMutation({
    mutationFn: (data) => postAddress({ token, data }),
    onMutate: () => {
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait while your address is being updated.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },
    onSuccess: (data, variables, context) => {
      const message = data?.message || 'Success';

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: message,
      });

      setTimeout(() => {
        onSuccess();
      }, 2000);
    },
    onError: (error, variables, context) => {
      const message = error.response?.data?.message || 'Error occurred';

      // Close loading and show error message
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
      });

    },
    onSettled: () => {

    },
  });
}

export default useAddressPostData